module.exports = __webpack_public_path__ + "img/setup_icon.fd1c7053.svg";